export default "__VITE_ASSET__CiJwc1dZ__"